import { render, staticRenderFns } from "./ListaPost.vue?vue&type=template&id=716ce7ca"
import script from "./ListaPost.vue?vue&type=script&lang=js"
export * from "./ListaPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports